import type { Employee } from "models";
import { APIService, tryRes } from "services";

class EmployeeService extends APIService<Employee> {
  async getDealersById(dealerId: string): Promise<Employee[]> {
    const response = await fetch(`${this._endpoint}/dealer/${dealerId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    return tryRes<Employee[]>(response);
  }

  async getEmails(): Promise<string[]> {
    const res = await fetch(`${this._endpoint}/emails`);
    return tryRes<string[]>(res);
  }

  async getEmployeesByDealerId(dealerId: string): Promise<Employee[]> {
    const res = await fetch(`${this._endpoint}/dealer/${dealerId}`);
    return tryRes<Employee[]>(res);
  }

  async resetEmployeePassword(email: string): Promise<boolean> {
    const res = await fetch(`${this._endpoint}/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    return res.ok;
  }
}

export default new EmployeeService("employees");
